import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { LoadingComponentModule } from '../../components/loading/loading.module';
import { SvgIconModule } from "../../components/svg-icon";

import { AudioPlayerWrapper } from "./audio-player-wrapper.component"

@NgModule({
    declarations: [
        AudioPlayerWrapper,
    ],
    imports: [
        CommonModule,
        SvgIconModule,
        LoadingComponentModule
    ],
    exports: [
        AudioPlayerWrapper
    ]
})
export class AudioPlayerWrapperModule { }